export default function isString(str) {
    return Object.prototype.toString.call(str) === '[object String]';
}
